import React from 'react'
import {Routes, Route} from '@startlibs/components'//  use this
import {AuditLog} from './controlPanel/AuditLog'
import {ControlPanelSidebar} from './controlPanel/ControlPanelSidebar'
import {PageContent, PageWrapper} from './steps/RequestSidebar'
import {NotificationSettings} from './controlPanel/NotificationSettings'
import {PageLoadingSuspense} from '../components/PageLoading'
import {StaffManagement} from './controlPanel/StaffManagement'
import {DivisionManagement} from './controlPanel/DivisionManagement'
import {SuspensePage} from '../components/SuspensePage'
import { ExportCSV } from './controlPanel/ExportCSV'
import { SUPER } from '../enums/UserRole'
import { lazyUserInfo } from '../components/WithProvider'
import { Jurisdiction } from './controlPanel/Jurisdiction'
import { PaymentFees } from './controlPanel/PaymentFees'
import { Analytics } from './controlPanel/Analytics'
import { IntakeFormsConfigPage } from './controlPanel/IntakeForms'
import { CaseReportSettings } from './controlPanel/CaseReportSettings'

export const AdminControlPanel = () => {

  const userInfo = lazyUserInfo.read()

  return <PageWrapper responsiveWorkaround controlPanel>
    <ControlPanelSidebar/>
    <PageContent controlPanel>
      <PageLoadingSuspense>
        <Routes>
          <Route path="/admin/control/audit" element={<AuditLog />}/>
          {userInfo.role === SUPER && <Route path="/admin/control/intake-forms" element={<IntakeFormsConfigPage />}/>}
          {userInfo.role === SUPER && <Route path="/admin/control/case-report" element={<CaseReportSettings />}/>}
          {userInfo.role === SUPER && <Route path="/admin/control/analytics" element={<Analytics />}/>}
          {userInfo.role === SUPER && <Route path="/admin/control/export" element={<ExportCSV />}/>}
          {userInfo.role === SUPER && <Route path="/admin/control/jurisdictions" element={<Jurisdiction />}/>}
          {userInfo.role === SUPER && <Route path="/admin/control/paymentfees" element={<PaymentFees />}/>}
          <Route path="/admin/control/staff" element={<SuspensePage Component={StaffManagement}/>}/>
          <Route path="/admin/control/divisions" element={<SuspensePage Component={DivisionManagement} />}/>
          <Route path="/admin/control/notifications" element={<NotificationSettings />}/>
        </Routes>
      </PageLoadingSuspense>
    </PageContent>
  </PageWrapper>
}
